import React from 'react';
import PropTypes from 'prop-types';
import {
  Empty,
  Table,
  Tag,
} from 'antd';

import i18n from '../../config/i18n';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
  DIETITIAN_ID,
  PHARMACIST_ID,
  PATIENT_ID,
  DOCTOR,
  ASSISTANT,
  NURSE,
  DIETITIAN,
  PHARMACIST,
  PATIENT,
} from '../../constants/RoleConstants';
import '../../styles/css/UserTable.css';

const roleNames = {
  [DOCTOR_ID]: i18n.t(DOCTOR),
  [ASSISTANT_ID]: i18n.t(ASSISTANT),
  [NURSE_ID]: i18n.t(NURSE),
  [DIETITIAN_ID]: i18n.t(DIETITIAN),
  [PHARMACIST_ID]: i18n.t(PHARMACIST),
  [PATIENT_ID]: i18n.t(PATIENT),
};

const columns = [
  {
    title: i18n.t('role'),
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: i18n.t('name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: i18n.t('email'),
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: i18n.t('actions'),
    dataIndex: 'actions',
    key: 'actions',
  },
];

const genData = (users, actions) => (
  users.map(user => ({
    key: user.id,
    role: <Tag color="#3498db">{roleNames[user.roleId]}</Tag>,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    actions: actions.map(action => action(user)),
  }))
);

const UserTable = ({
  title,
  users,
  actions,
}) => (
  <Table
    className="user-table"
    title={() => title}
    columns={columns}
    dataSource={genData(users, actions)}
    locale={{
      emptyText: <Empty description={<span className="lead">{i18n.t('noMemberMsg')}</span>} />,
    }}
  />
);

UserTable.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    roleId: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  })),
  actions: PropTypes.arrayOf(PropTypes.func),
};

UserTable.defaultProps = {
  title: '',
  users: [],
  actions: [],
};

export default UserTable;



// WEBPACK FOOTER //
// ./src/components/team/UserTable.js